// removed by extract-text-webpack-plugin
module.exports = {"item-mobile":"ProductAccordion-module-item-mobile-237O3","itemMobile":"ProductAccordion-module-item-mobile-237O3","icon":"ProductAccordion-module-icon-2zqf0"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/ProductAccordion/ProductAccordion.module.scss
// module id = 1273
// module chunks = 0